"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollbar-size/~/babel-runtime/helpers/classCallCheck.js
// module id = 1768
// module chunks = 0